<template>
  <div>
    <v-row justify="center">
      <v-col
        :xl="6"
        :lg="8"
        :xs="10"
      >
        <v-row>
          <v-col>
            <h1>Payment Complete</h1>

            <p>Thank you for choosing havebike! Your payment has been received.</p>

            <a href="https://www.havebike.co.uk">
              <v-btn
                color="primary"
                large>
                Return Home
              </v-btn>
            </a>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'Complete'
}
</script>
